export default "<div class=\"cssload-speeding-wheel\"></div>";